//Angular
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
// Core
import { HttpRequestModel, ObjectUtils, RoleService, ToasterType } from '@cv-invision/core';
// Services
import { ConnectionService } from 'ng-connection-service';
import { AppInformationService, AppService, BroadcastService, ErrorFactoryService } from '@cv-invision/core';

@Injectable()
export class GlobalConfigurationHttpRequestInterceptor extends HttpRequestModel implements HttpInterceptor {

	constructor(
		protected router: Router,
		protected errorFactoryService: ErrorFactoryService,
		protected connectionService: ConnectionService,
		protected broadcastService: BroadcastService,
		protected roleService: RoleService,
		protected appService: AppService,
		protected appInfo: AppInformationService
	) {
		super(router, connectionService, broadcastService, roleService, errorFactoryService, appInfo, appService);
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const allowHandler = ObjectUtils.containsPattern(request.url, this.appService.getHandledByOtherExceptions());

		if (allowHandler) {
			return this.handleRequest(request, next);
		}
		return next.handle(request);
	}

	/**
	 * Capture the current request and performs some validations
	 * @param request
	 * @param next
	 */
	protected handleRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

		return next.handle(request).pipe(
			map((event: HttpEvent<any>) => this.onSuccessRequest(event)),
			catchError((err: HttpErrorResponse) => {
				if (err && err.status === 403) {
					this.broadcastService.broadcast({
						name: ToasterType.ERROR,
						event: {
							error: `You don't currently have permission to perform this action`
						}
					});
					return throwError(err) as Observable<any>;
				} else if (err && err.status === 404) {
					let errorMessage = '';
					if ((err.error && err.error.error) || err.message) {
						errorMessage = err.error && err.error.error ? err.error.error : err.message;
					} else {
						errorMessage = 'Page not found';
					}

					this.broadcastService.broadcast({
						name: ToasterType.ERROR,
						event: {
							error: errorMessage
						}
					});

					return throwError(err) as Observable<any>;
				} else {
					return this.onErrorRequest(err);
				}

			})
		);
	}

}
